import classNames from "classnames";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import EmptyStateCircle from "../../components/composed/EmptyStateCircle";

export default function OfferNotGenerated({
  whiteLabelStyle
}: {
  whiteLabelStyle?: any;
}) {
  return (
    <div className="px-0 mb-12 md:mb-0 md:px-4 overflow-auto">
      <div className="hidden md:flex items-center text-base font-medium">
        <h3
          className={classNames(
            "text-sm text-gray-700 font-medium w-max border-b-2 py-2 pr-2",
            whiteLabelStyle?.theme?.color?.border || "border-indigo-500"
          )}
        >
          Loan Offer
        </h3>
      </div>
      <div className="mt-10">
        <EmptyStateCircle>
          <div className="flex flex-col items-center text-center gap-3">
            <DocumentTextIcon className="h-9 w-9 text-gray-400" />
            <h5 className="text-base font-semibold text-gray-800">
              Offer not generated yet
            </h5>
            <p className="text-sm text-gray-500 max-w-sm leading-relaxed">
              The loan offer has not been generated yet. For further details,
              please contact the lender's team.
            </p>
          </div>
        </EmptyStateCircle>
      </div>
    </div>
  );
}
